// What happened during a meal, as it happened: the teacher's "behaviour"
// context (Matt, 2026-10-02: "it should know what my behavior has been
// while interacting with the meal"). One event per row under
// <hat>/cooking/lessons/<id>/trace; CookScreen writes, the teacher reads a
// summary (paceSummary) with every question.
import { dbPost, dbGet } from '../store/db.js';
import { coursePath } from './course.js';

export const tracePath = (hat, id) => `${coursePath(hat)}/lessons/${id}/trace`;

export function logTrace (hat, lessonId, event) {
  if (!hat || !lessonId) return Promise.resolve();
  return dbPost(tracePath(hat, lessonId), { at: Date.now(), ...event }).catch(() => {});
}

export async function loadTrace (hat, lessonId) {
  if (!hat || !lessonId) return [];
  const rows = await dbGet(tracePath(hat, lessonId)).catch(() => null);
  return Object.values(rows || {}).sort((a, b) => a.at - b.at);
}

const minutes = (ms) => Math.round(ms / 60000);

/** A few plain sentences about tonight so far. Pure. */
export function paceSummary (trace, recipe, now = Date.now()) {
  if (!trace?.length) return '';
  const started = trace.find((e) => e.type === 'start')?.at;
  const cooking = trace.find((e) => e.type === 'cooking')?.at;
  const parts = [];
  if (started) parts.push(`Started ${minutes(now - started)} minutes ago (the lesson plans on about ${recipe?.minutes || '?'}).`);
  if (cooking) parts.push(`Prep took ${minutes(cooking - started)} minutes; the heat has been on for ${minutes(now - cooking)}.`);
  const extended = trace.filter((e) => e.type === 'timer-extended');
  if (extended.length) parts.push(`Timers extended ${extended.length} time${extended.length === 1 ? '' : 's'} (${extended.map((e) => e.label).filter(Boolean).join(', ')}).`);
  const backs = trace.filter((e) => e.type === 'step' && e.delta < 0).length;
  if (backs) parts.push(`Went back a step ${backs} time${backs === 1 ? '' : 's'}.`);
  const asked = trace.filter((e) => e.type === 'asked').length;
  if (asked) parts.push(`Asked ${asked} question${asked === 1 ? '' : 's'} so far tonight.`);
  const steps = trace.filter((e) => e.type === 'step' && e.phase === 'steps');
  if (steps.length >= 2) {
    const gaps = steps.slice(1).map((e, i) => e.at - steps[i].at);
    parts.push(`Cooking steps have taken ${minutes(gaps.reduce((a, b) => a + b, 0) / gaps.length) || '<1'} minutes each on average.`);
  }
  return parts.join(' ');
}
